module.exports = __webpack_public_path__ + "img/anna-malacrida.5952be80.png";